import React, { PropsWithChildren } from 'react';
import { ReactSVG } from 'react-svg';
import { useDropdown } from 'Hooks/Common';

import TooltipBlock, { TooltipBlockProps } from './TooltipBlock';

import TooltipIcon from 'Assets/images/icons/tooltip-icon.svg';

const Tooltip = ({ children, ...blockProps }: PropsWithChildren<TooltipBlockProps>) => {
  const [containerRef, isOpen, open, close] = useDropdown();

  return (
    <div ref={containerRef} className="text-tooltip">
      <ReactSVG
        className="text-tooltip__trigger"
        src={TooltipIcon}
        onClick={isOpen ? close : open}
      />
      {isOpen && <TooltipBlock {...blockProps}>{children}</TooltipBlock>}
    </div>
  );
};

export default Tooltip;
